"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Label = _interopRequireDefault(require("./Label"));

var _GraphComponent2 = _interopRequireDefault(require("./GraphComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Node =
/*#__PURE__*/
function (_GraphComponent) {
  _inherits(Node, _GraphComponent);

  function Node() {
    var _this;

    _classCallCheck(this, Node);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
    Node.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(Node, [{
    key: "isIncidentEdgeInResult",
    value: function isIncidentEdgeInResult() {
      for (var it = this.getEdges().getEdges().iterator(); it.hasNext();) {
        var de = it.next();
        if (de.getEdge().isInResult()) return true;
      }

      return false;
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._label.getGeometryCount() === 1;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println("node " + this._coord + " lbl: " + this._label);
    }
  }, {
    key: "computeIM",
    value: function computeIM(im) {}
  }, {
    key: "computeMergedLocation",
    value: function computeMergedLocation(label2, eltIndex) {
      var loc = _Location.default.NONE;
      loc = this._label.getLocation(eltIndex);

      if (!label2.isNull(eltIndex)) {
        var nLoc = label2.getLocation(eltIndex);
        if (loc !== _Location.default.BOUNDARY) loc = nLoc;
      }

      return loc;
    }
  }, {
    key: "setLabel",
    value: function setLabel() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && Number.isInteger(arguments[0])) {
        var argIndex = arguments[0],
            onLocation = arguments[1];

        if (this._label === null) {
          this._label = new _Label.default(argIndex, onLocation);
        } else this._label.setLocation(argIndex, onLocation);
      } else return _get(_getPrototypeOf(Node.prototype), "setLabel", this).apply(this, arguments);
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "mergeLabel",
    value: function mergeLabel() {
      if (arguments[0] instanceof Node) {
        var n = arguments[0];
        this.mergeLabel(n._label);
      } else if (arguments[0] instanceof _Label.default) {
        var label2 = arguments[0];

        for (var i = 0; i < 2; i++) {
          var loc = this.computeMergedLocation(label2, i);

          var thisLoc = this._label.getLocation(i);

          if (thisLoc === _Location.default.NONE) this._label.setLocation(i, loc);
        }
      }
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.insert(e);

      e.setNode(this);
    }
  }, {
    key: "setLabelBoundary",
    value: function setLabelBoundary(argIndex) {
      if (this._label === null) return null;
      var loc = _Location.default.NONE;
      if (this._label !== null) loc = this._label.getLocation(argIndex);
      var newLoc = null;

      switch (loc) {
        case _Location.default.BOUNDARY:
          newLoc = _Location.default.INTERIOR;
          break;

        case _Location.default.INTERIOR:
          newLoc = _Location.default.BOUNDARY;
          break;

        default:
          newLoc = _Location.default.BOUNDARY;
          break;
      }

      this._label.setLocation(argIndex, newLoc);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Node;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return Node;
}(_GraphComponent2.default);

exports.default = Node;

Node.constructor_ = function () {
  this._coord = null;
  this._edges = null;
  var coord = arguments[0],
      edges = arguments[1];
  this._coord = coord;
  this._edges = edges;
  this._label = new _Label.default(0, _Location.default.NONE);
};